module.exports = __webpack_public_path__ + "img/bg_ghost_13@3x.904b0c5f.png";